import { getUserId } from 'app/auth/selectors';
import { ensureScratchBranchRoutine } from 'app/branches/actions';
import { createScratchBranchMutation } from 'app/branches/api';
import { getRoutineSaga } from 'app/common/utils/new-sagas';
import { getProjectId } from 'app/schema';
import type { SagaIterator } from 'redux-saga';
import { all, call, select, takeLatest } from 'redux-saga/effects';

export function* ensureScratchBranchSaga(_payload: undefined, { name }: { name?: string } = {}): SagaIterator {
  const userId = yield select(getUserId);
  const projectId = yield select(getProjectId);
  return yield call(createScratchBranchMutation, projectId, userId, name);
}

export default function* root(): SagaIterator {
  yield all([
    takeLatest(
      ensureScratchBranchRoutine.requested,
      getRoutineSaga(ensureScratchBranchRoutine, ensureScratchBranchSaga)
    )
  ]);
}
